import type { FiltersConfigState } from '@/reducers/filtersConfig';
import { SearchState } from '@/reducers/search';
import { FloatingButtonState } from '..';
import { create as createNoAllCategoriesAndLocationsStrategy } from './categoriesAndLocationStrategy';
import { create as createSearchButtonExitFromViewport } from './searchButtonOutOfViewport';
import { create as createSearchNotSavedStrategy } from './searchNotSavedDisplayStrategy';

export type DisplayStrategyFactory = (
  state: FloatingButtonState
) => DisplayStrategy;

export type DisplayStrategyCallback = (
  search: SearchState,
  filtersConfig: FiltersConfigState
) => Promise<boolean>;

export interface DisplayStrategy {
  [index: string]: DisplayStrategyCallback;
}

export const createDisplayStrategies: DisplayStrategyFactory = (
  state: FloatingButtonState
) => ({
  searchNotSaved: createSearchNotSavedStrategy(state),
  noAllCategoriesAndLocations: createNoAllCategoriesAndLocationsStrategy(),
});

export type ResizeStrategyFactory = (
  state: FloatingButtonState,
  setState: (s: Pick<FloatingButtonState, keyof FloatingButtonState>) => void
) => ResizeStrategy;

export type ResizeStrategyCallback = (
  search: SearchState,
  filtersConfig: FiltersConfigState
) => Promise<boolean>;

export interface ResizeStrategy {
  [index: string]: ResizeStrategyCallback;
}

export const createResizeStrategies: ResizeStrategyFactory = (
  state: FloatingButtonState,
  setState: (s: Pick<FloatingButtonState, keyof FloatingButtonState>) => void
) => ({
  searchButtonExitFromViewport: createSearchButtonExitFromViewport(
    state,
    setState
  ),
});
